import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import { getApi } from "../../redux/rest/restSlice";
import { LIST_PERMISSIONS } from "../../constants/actionTypes";
import { unwrapResult } from "@reduxjs/toolkit";
import get from "lodash/get";
import { useDispatch } from "react-redux";
import DataTable from "../DataTable";

const { Text } = Typography;

const PermissionsOverviewTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const dispatch = useDispatch();

  const fetchPermissionsList = () => {
    setLoading(true);
    dispatch(
      getApi({
        endpoint: LIST_PERMISSIONS,
      })
    )
      .then(unwrapResult)
      .then((result) => {
        setLoading(false);
        setData(get(result, "data"));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPermissionsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const firstLoad = loading && !(data && data.length);

  return (
    <Spin spinning={loading && !firstLoad}>
      <DataTable
        skeleton={firstLoad}
        rowKey="id"
        className="mt-20"
        dataSource={data}
        pagination={false}
        emptyProps={{ noun: "permissions" }}
        columns={[
          {
            title: "Sr. No.",
            key: "serial_no",
            className: "col-index",
            width: 80,
            responsive: ["sm"],
            render: (_, __, index) => <Text>{index + 1}</Text>,
          },
          {
            title: "Group",
            dataIndex: "group",
            key: "group",
            render: (group) => group || "-",
          },
          {
            title: "Permission",
            dataIndex: "permission",
            key: "permission",
            render: (permission) => permission || "-",
          },
        ]}
      />
    </Spin>
  );
};

export default PermissionsOverviewTable;
